module.exports = __webpack_public_path__ + "img/23.c1b4a710.png";